import { getStartIndexStringFromLowerBound as e, getStartIndexStringFromUpperBound as n, lastOfArray as t, getQueryMatcher as r, getSortComparator as s } from "rxdb/plugins/core";
import { runReadTask as a } from "./indexeddb-helpers.js";
import { getIndexId as i } from "./indexeddb-index-helpers.js";
export async function queryIndexedDB(t, o) {
  return a(t, async a => {
    var c = o.queryPlan,
      u = o.query,
      d = u.skip ? u.skip : 0,
      l = d + (u.limit ? u.limit : 1 / 0),
      y = t.internals.storeNames.documentStore,
      m = t.settings.batchSize ? t.settings.batchSize : 50,
      g = !1;
    c.selectorSatisfiedByIndex || (g = r(t.schema, u));
    var v = c.index,
      f = !c.sortSatisfiedByIndex,
      h = v,
      x = c.startKeys,
      p = e(t.schema, h, x),
      B = c.endKeys,
      I = n(t.schema, h, B),
      b = [],
      S = a.objectStore(y),
      K = i(t.internals, h),
      w = S.index(K);
    g || o.query.limit || (m = 1e5);
    var D = !1;
    if (await runBatchedCursor(t, c, w, m, p, I, K, e => {
      for (var n = 0; n < e.length; n++) {
        var t = e[n].d;
        if (D || g && !g(t) || b.push(t), !f && b.length === l) {
          D = !0;
          break;
        }
      }
      return !D;
    }), f) {
      var P = s(t.schema, u);
      b = b.sort(P);
    }
    return {
      documents: b = b.slice(d, l)
    };
  });
}
export async function runBatchedCursor(e, n, r, s, a, i, o, c) {
  var u = e.settings.IDBKeyRange ? e.settings.IDBKeyRange : IDBKeyRange,
    d = e.internals.getIndexableStringByIndexId[o];
  if ("function" == typeof r.getAll && 1 !== s) for (var l, y = !0, m = !1, g = async function () {
      l && (a = d(l.d));
      var e = u.bound(a, i, !y || !n.inclusiveStart, !n.inclusiveEnd);
      y = !1;
      var o = r.getAll(e, s);
      await new Promise((e, n) => {
        o.onerror = n, o.onsuccess = n => {
          var r = n.target.result;
          (l = t(r), 0 !== r.length) && !1 === c(r) && (m = !0);
          r.length < s && (m = !0), e();
        };
      });
    }; !m;) await g();else {
    var v = u.bound(a, i, !n.inclusiveStart, !n.inclusiveEnd),
      f = r.openCursor(v);
    await new Promise(e => {
      f.onsuccess = function (n) {
        var t = n.target.result;
        if (t) {
          var r = t.value;
          c([r]) ? t.continue() : e();
        } else e();
      };
    });
  }
}
export async function countIndexedDB(t, r) {
  return a(t, async s => {
    var a,
      o = r.queryPlan,
      c = t.internals.storeNames.documentStore,
      u = o.index,
      d = u,
      l = o.startKeys,
      y = e(t.schema, d, l),
      m = o.endKeys,
      g = n(t.schema, d, m),
      v = s.objectStore(c);
    a = 1 === u.length && u[0] === t.primaryPath ? i(t.internals, ["_deleted", t.primaryPath]) : i(t.internals, d);
    var f = v.index(a),
      h = (t.settings.IDBKeyRange ? t.settings.IDBKeyRange : IDBKeyRange).bound(y, g, !o.inclusiveStart, !o.inclusiveEnd),
      x = f.count(h);
    return {
      count: await new Promise((e, n) => {
        x.onsuccess = function () {
          e(x.result);
        }, x.onerror = n;
      }),
      mode: "fast"
    };
  });
}